module.exports = __webpack_public_path__ + "static/15-fd2d56599f427f240fe8026f321e9200.png";